import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * ** WebHotelier**
 *
 * @exports bs_50
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isPropertyUsingLoyaltyRates = [1158281, 1158282].includes(thn.data.propertyId);

  let webhotelierUpdater;

  /**
     * @memberOf module:bs_50
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    const isBookingEngine = window.location.hostname.match(/reserve-online.net/);
    const isHotelVigla = thn.data.propertyId === 1036891;
    const hotelLuxembourgHomepage = window.location.hostname.includes('www.hotelluxembourg.gr');
    const isHotelLuxembourg = thn.data.accountUserId === 1042851;
    const isZafoliaHotel = thn.data.accountUserId === 1042631;
    const zafoliaHotelHomepage = window.location.hostname.includes('athenszafoliahotel');
    const zafoliaParamLangDic = {
      el: 'athens-zafolia-hotel', // greek
      fr: 'hotel',
      de: 'das-hotel',
      es: 'el-hotel',
    };
    const portoPalaceHotelHomepage = window.location.hostname.includes('www.portopalace.gr');
    const portoPalaceHotel = thn.data.propertyId === 1036481;

    return new Promise(function (resolve, reject) {

      if (isHotelVigla && !isBookingEngine) {
        const lang = window.location.pathname.match(/^\/\w{2}\//)?.[0].replace(/\//g, '').toLowerCase();
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
        resolve('en');
      }

      // Zafolia Hotel
      if (isZafoliaHotel && zafoliaHotelHomepage) {
        const lang = Object.keys(zafoliaParamLangDic).find((key) => zafoliaParamLangDic[key] === window.location.pathname.replace(/\//g, '')) || '';
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
        resolve('en');
      }

      // Hotel Luxembourg
      if (isHotelLuxembourg && hotelLuxembourgHomepage) {
        const lang = window.location.pathname.replace(/\//g, '');
        const language = lang === 'gr' ? 'el' : lang;

        if (language && ctx.langs.test(language)) {
          resolve(language);
          return;
        }
      }

      // Porto Palace Hotel
      if (portoPalaceHotel && portoPalaceHotelHomepage) {
        const language = document.querySelector('.dropdown-content .selected')?.textContent;

        if (language && ctx.langs.test(language)) {
          resolve(language);
          return;
        }
        resolve('el');
      }

      reject('no_language');
    });
  };
  /**
     *
     * Here we check if the user go to User register page.
     *
     * @memberOf module:bs_50
     *
     * @param {object} ctx - The context object.
    */
  engine.boot = function boot() {

    const container = document.querySelector('#step-1');

    if (container) {
      let pageRefresh = thn.debounce(thn.pageCheck, 600);
      thn.observeDom(container, pageRefresh, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.shutdown(() => {
        pageRefresh.cancel();
        thn.stopObserveDom(container, pageRefresh);
        pageRefresh = null;
      });
    }

    //  Hotel Luxembourg, NLH Hotels
    const forcePageCheckUserList = [1042851, 1042825, 1042617, 1046579, 1042150].includes(thn.data.accountUserId);

    const onDataLayerPush = ({ message }) => {
      if (forcePageCheckUserList && message[1] === 'Search') {
        thn.pageCheck({ force: true });
      }
    };
    thn.bus.on('dataLayer:push', onDataLayerPush);
    thn.shutdown(() => {
      thn.bus.detach('dataLayer:push', onDataLayerPush);
    });

    // Detect element DOM

    const containerRooms = document.querySelector('.items');
    if (containerRooms) {
      let roomsRefresh = thn.debounce(thn.pageCheck, 600);
      thn.observeDom(containerRooms, roomsRefresh, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.shutdown(() => {
        roomsRefresh.cancel();
        thn.stopObserveDom(containerRooms, roomsRefresh);
        roomsRefresh = null;
      });
    }
  };

  /**
     * @memberOf module:bs_50
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    let isLogged = false;
    const app = window.app;

    if (app && app.loyalty && app.loyalty.logged) {
      isLogged = true;
    }

    return isLogged;
  };

  /**
     * @memberOf module:bs_50
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    setTimeout(thn.pageCheck, 500);
  };

  /**
     * @memberOf module:bs_50
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const usersNeedRefreshTools = [1040059].includes(thn.data.accountUserId);

    const container = document.querySelector('#rm-box');

    if (container && !webhotelierUpdater) {
      webhotelierUpdater = thn.debounce(() => {
        if (usersNeedRefreshTools) {
          thn.pageCheck({ force: true });
        } else {
          ctx.widget.update();
        }
      }, 600);
      thn.observeDom(container, webhotelierUpdater, {
        subtree: false,
        characterData: false,
      });

      thn.pageUnload(function () {
        webhotelierUpdater.cancel();
        thn.stopObserveDom(container, webhotelierUpdater);
        webhotelierUpdater = null;
      });
    }

    const containerRooms = document.querySelector('.items');
    if (containerRooms) {

      let priceRefresh = thn.debounce(() => {
        const loaderIsvisible = thn.isVisible(document.querySelector('.webhotelier-loader'));

        if (!loaderIsvisible) {
          ctx.widget.refresh();
        }
      }, 600);
      thn.observeDom(containerRooms, priceRefresh, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      thn.pageUnload(() => {
        priceRefresh.cancel();
        thn.stopObserveDom(containerRooms, priceRefresh);
        priceRefresh = null;
      });
    }
  };

  /**
     * @memberOf module:bs_50
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = !!url.pathname.match(/book-now/) || url.hostname.match(/reserve-online|book/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    url.searchParams.delete('voucher');
    url.searchParams.delete('bk_code');
    url.searchParams.delete('ctl13_promocode');
    url.searchParams.delete('vouchercheck');
    url.searchParams.delete('bkcode');

    if (!url.searchParams.has('daterange')) {
      // https://kanikahotels.com/book-now/?currency=EUR&propertyname=Olympic+Lagoon+Resorts+-+Ayia+Napa&propertycode=KANIKALAG
      url.searchParams.set('checkin', '[date_begin]');
      url.searchParams.set('lang', '[language]');
      url.searchParams.set('checkout', '[date_end]');
      url.searchParams.set('rooms', '[rooms]');
      url.searchParams.set('adults', '[adults]');
      url.searchParams.set('children', '[children]');
      url.searchParams.set('nights', '[nights]');
      url.searchParams.set('currency', '[currency]');

      ctx.newUrl = url.toString();

      ctx.newData.dateBegin = (ctx.newData?.dateBegin || ctx.data?.dateBegin)?.replace(/\//g, '-');
      ctx.newData.dateEnd = (ctx.newData?.dateEnd || ctx.data?.dateEnd)?.replace(/\//g, '-');

    } else {
      // https://kanikahotels.com/book-now/?propertyname=Olympic+Lagoon+Resorts+-+Ayia+Napa&propertycode=KANIKALAG&daterange=Mon+11+Sep+2023+-+Thu+14+Sep+2023&checkin=2023-09-11&checkout=2023-09-14&rooms=1&adults=2&children=0&infants=0&nights=3&voucher=&currency=EUR

      ctx.newUrl = url.toString();
    }

    return ctx;
  };

  /**
       *
       * @memberOf module:bs_50
       *
       */
  const roomDetailsParseData = (nights = '', guests = '') => {
    const roomsInfoEl = document.querySelector('.data, .avl-mobile');
    const refundableKeyWords = /gratuita|gratuito|ακύρωση|free|pagesë|gratuïta|анулация|免费取消|naknade|gratis|peruutus|gratuite|stornierung|ביטול|lemondás|キャンセル無料|무료 취소|rezygnacja|gratuită|бронирования|okazivanje|fri| ücretsiz'/;

    if (!roomsInfoEl) {
      return undefined;
    }

    const roomDetailsArray = [...roomsInfoEl.querySelectorAll('tbody, .mobile-rate')]
      .map((room) => {
        const roomName = room.querySelector('.room .name, h2')?.textContent;
        const occupancy = guests;
        const roomType = getRoomType(roomName);
        const roomRates = [...room.querySelectorAll('tr, .rate-area')]
          .map((rate) => {
            const priceNameItem = rate.querySelector('.spec .title, .rate-content .rate-title a');
            const priceName = priceNameItem?.textContent?.trim();
            const priceItem = rate.querySelector('.price .val')?.textContent.split('×');
            const price = priceItem?.length > 1 ? thn.parseNumber(priceItem?.[1]) : thn.parseNumber(priceItem?.textContent);
            if (!(priceName && price)) {
              return undefined;
            }
            const isBreakfast = !!rate.querySelector('.spec .tooltip.black, .rate-content .tooltip.black');
            const isRefundableEl = rate.querySelector('.spec .tooltip:not(.blue, .black), .rate-content .tooltip:not(.blue, .black)');
            const isRefundableStr = isRefundableEl?.textContent?.toLowerCase();
            const isRefundable = !!refundableKeyWords.test(isRefundableStr);
            const rates = {
              id: '',
              name: priceName,
              totalNight: price / nights,
              breakfast: isBreakfast,
              refundable: isRefundable,
            };
            return rates;
          }).filter(Boolean);

        return {
          id: '',
          name: roomName,
          adults: occupancy,
          children: 0, // the max occupancy does not distinguishes between adults and children
          type: roomType,
          prices: roomRates,
        };
      }).filter(Boolean);

    return roomDetailsArray;
  };

  /**
     * @memberOf module:bs_50
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {

    const widgetData = {};
    if (window.location.pathname.includes('booking')) {
      return widgetData;
    }

    let nights;
    const dateBegin = document.querySelector('[name="checkin"]')?.value;
    const dateEnd = document.querySelector('[name="checkout"]')?.value;
    const adults = thn.parseNumber(document.querySelector('[name="adults"]')?.value);
    const children = thn.parseNumber(document.querySelector('[name="children"]')?.value);
    const infants = thn.parseNumber(document.querySelector('[name="infants"]')?.value);
    const guests = adults + children + infants;
    // Dates
    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/-/g, '/');
      widgetData.dateEnd = dateEnd.replace(/-/g, '/');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }
    // Rooms
    const selectRooms = document.querySelector('#select-rooms');
    widgetData.rooms = thn.parseNumber(thn.parseUrlParameter('rooms')) || thn.parseNumber(selectRooms?.selectedOptions?.[0]?.value) || 1;

    // Guests
    widgetData.roomsDispo = [];

    for (let i = 0; widgetData.rooms > i; i += 1) {
      const roomInfo = {
        adults: adults,
        children: children + infants,
        childrenAges: [],
      };

      if (roomInfo.children) {
        for (let j = 1; j <= roomInfo.children; j += 1) {
          // children: 3-12, infants: 0-2
          roomInfo.childrenAges.push(j <= roomInfo.children - thn.parseNumber(thn.parseUrlParameter('infants')) ? 11 : 1);
        }
      }
      widgetData.roomsDispo.push(roomInfo);
    }

    // Price & Currency || No Availability
    const isArabicLanguage = thn.data.language === 'ar';
    const arabicToWestern = (str) => str?.replace(/[٠-٩]/g, (c) => c.charCodeAt(0) - 1632); // Transform Arabic numbers to Western
    const userToExclude = [1048754].includes(thn.data.accountUserId); // Exclude rooms
    const roomsToExclude = /double room promo/i;
    const filterToExclude = userToExclude ? (el) => thn.isVisible(el) && !el.querySelector('.room .name')?.textContent?.match(roomsToExclude) : (el) => thn.isVisible(el);
    const roomsArray = [...document.querySelectorAll('#rm-box .avl-mobile .mobile-rate')].length > 0
      ? [...document.querySelectorAll('#rm-box .avl-mobile .mobile-rate')].filter(filterToExclude)
      : [...document.querySelectorAll('.data.rmtbl tbody, .rate-area')].filter(filterToExclude);
    const roomsData = roomsArray.map((room) => {
      const price = isPropertyUsingLoyaltyRates ? room.querySelector('[data-status=AVL]')?.dataset?.smartguest : room.querySelector('.price .val')?.textContent || room.querySelector('.finalpricing')?.textContent;
      return {
        price: isArabicLanguage ? thn.parseNumber(arabicToWestern(price?.slice(0, -1)?.replace(/٬/g, ''))) : thn.parseNumber(price),
        currency: thn.parseCurrency(room.querySelector('.price .val')?.textContent),
      };
    }).filter((room) => !!room.price || !!room.currency).sort((a, b) => a.price - b.price);

    const isNoAvailability = (!!document.querySelector('.avl-warn') && !document.querySelector('.room') && !document.querySelector('.data')) || thn.empty(roomsData);
    if (!thn.empty(roomsData) && nights) {
      widgetData.price = window.location.pathname.match(/book-now/) ? roomsData[0].price / nights : (roomsData[0].price * widgetData.rooms) / nights;
      widgetData.currency = roomsData[0].currency;
      widgetData.roomDetails = roomDetailsParseData(nights, guests);
      widgetData.set = true;

    } else if (isNoAvailability) {
      widgetData.noRooms = true;
    }
    return widgetData;
  };
  /**
     * @memberOf module:bs_50
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v2 = function priceParseData_v2(ctx) {

    const widgetData = {};

    // Dates
    let nights;
    const dateBegin = document.querySelector('.datepicker__info-text--start-day')?.textContent;
    const dateEnd = document.querySelector('.datepicker__info-text--end-day')?.textContent;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms
    widgetData.rooms = thn.parseNumber(document.querySelector('#select-rooms')?.selectedOptions?.[0]?.value) || 1;

    // Guests
    const adultsDom = thn.parseNumber(document.querySelector('#select-adults')?.value) || 2;
    // We multiply the adults by the number of rooms, to control if the number of rooms increases but not the number of guests.
    widgetData.adults = adultsDom * widgetData.rooms;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices
    const prices = [...document.querySelectorAll('.book .price')].map((price) => thn.parseNumber(price?.textContent))?.filter(Boolean);

    if (!thn.empty(prices) && nights) {
      widgetData.currency = 'EUR';
      widgetData.price = Math.min(...prices) / nights;
      widgetData.set = true;
    } else if (thn.empty(prices) && nights) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_50
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    const gtmDataLayer = window.gtmDataLayer;

    if (gtmDataLayer) {

      let gtmDataLayerHelper = new thn.DataLayerHelper(window.gtmDataLayer, function (model, message) {
        if (message?.resid && ctx.widget.setData().isSet()) {
          ctx.widget.save();
        }
      }, true);

      thn.pageUnload(() => {
        gtmDataLayerHelper.cancel();
        gtmDataLayerHelper = null;
      });
    }
  };

  /**
     * @memberOf module:bs_50
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const gtmDataLayerByWindow = window.gtmDataLayer;
    const bookingIdByGtmDataLayer = thn.objectGet(gtmDataLayerByWindow, 'resid');

    if (bookingIdByGtmDataLayer) {
      thn.logger.debug('Saving data from window elemento', gtmDataLayerByWindow);
      widgetData.bookingId = bookingIdByGtmDataLayer;
      widgetData.dateBegin = thn.objectGet(gtmDataLayerByWindow, 'checkin')?.replace(/-/g, '/');
      widgetData.dateEnd = thn.objectGet(gtmDataLayerByWindow, 'checkout')?.replace(/-/g, '/');
      widgetData.currency = thn.objectGet(gtmDataLayerByWindow, 'currency');
      widgetData.price = thn.objectGet(gtmDataLayerByWindow, 'total');
      widgetData.promocode = thn.objectGet(gtmDataLayerByWindow, 'voucher');

      return widgetData;
    }

    // Dates
    let dateBegin = document.querySelector('#step-3 tr:nth-child(3) > td')?.textContent;
    let dateEnd = document.querySelector('#step-3 tr:nth-child(4) > td')?.textContent;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
      widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
    } else {
      dateBegin = document.getElementsByName('checkin')?.[0] || document.getElementById('date-input-fromd');
      dateEnd = document.getElementsByName('checkout')?.[0] || document.getElementById('date-input-tod');
      widgetData.dateBegin = dateBegin?.value?.replace(/-/g, '/');
      widgetData.dateEnd = dateEnd?.value?.replace(/-/g, '/');
    }

    // Currency
    let currency;
    const currencyField = document.getElementsByName('cur_iso');

    if (currencyField.length) {
      const currencyEl = document.querySelector('.price.total');
      const matchedCurrency = currencyEl?.textContent?.match(/[^\d\s,.]+/);

      currency = matchedCurrency?.length
        ? thn.getCurrencyCode(matchedCurrency[0])
        : currencyField[0].value;
    } else {
      currency = thn.parseCurrency(document.querySelector('.price.total')?.textContent);
    }

    if (currency) {
      widgetData.currency = currency;
    }

    // Price
    if (document.getElementsByClassName('price total').length) {
      widgetData.price = thn.parseNumber(document.getElementsByClassName('price total')[0].textContent);
    }

    // bookingId
    const thnBookingId = document.querySelector && document.querySelector('a.confirmation-link');
    if (thnBookingId) {
      widgetData.bookingId = thnBookingId.text;
    }

    // Guests
    if (widgetData.dateBegin && widgetData.dateEnd) {
      const nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      if (nights > 1) {
        const arrayGuests = document.querySelector('table tr:nth-child(6)>td')?.innerHTML?.trim()?.split('<br>');
        widgetData.adults = thn.parseNumber(arrayGuests?.[0]);
        widgetData.children = thn.parseNumber(arrayGuests?.[1]) + thn.parseNumber(arrayGuests?.[2]);
      } else {
        const arrayGuests = document.querySelector('table tr:nth-child(5)>td')?.innerHTML?.trim()?.split('<br>');
        widgetData.adults = thn.parseNumber(arrayGuests?.[0]);
        widgetData.children = thn.parseNumber(arrayGuests?.[1]) + thn.parseNumber(arrayGuests?.[2]);
      }
    }

    // PromoCode
    widgetData.promocode = thn.widgets.price.getPromocode().promocode;

    return widgetData;
  };
  /**
     * @memberOf module:bs_50
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const _GlobalTokens = window._GlobalTokens;

    const promocode = document.querySelector('input[name="bk_code"]')?.value
      || document.querySelector(".inside [name='voucher']")?.getAttribute('value');

    ctx.promocode = (_GlobalTokens?.PromoCode || _GlobalTokens?.GroupCode) || promocode || ctx.promocode;

    return ctx.promocode;
  };

  return engine;

}

export { factory };
